import { connect } from 'react-redux';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  CheckboxGroup,
  SelectField,
  TextField,
} from '../../../../common/components/ReduxFormField';
import { Box, Button, InfoButton } from '../../../../common/components';
import { required } from 'redux-form-validators';
import SchemesToUpdate from '../SchemesToUpdate/SchemesToUpdate';

const QUOTE_OPTIONS = [
  { label: 'Quote', value: 'Quote' },
  { label: 'Decline', value: 'Decline' },
];
const EXCLUDE_OPTIONS = [
  { label: 'Yes', value: 'exclude' },
  { label: 'No', value: 'do_not_exclude' },
];
const OVERRIDE_OPTIONS = [
  { label: 'Yes', value: 'override' },
  { label: 'No', value: 'do_not_override' },
];

const ExclusionField = ({ input }) => {
  const rule = input.value.rule;

  if (rule === 'Quote') {
    return (
      <Field
        label={
          <>
            Exclude from panel if psychiatric question is overridden?{' '}
            <InfoButton
              content={
                'Quotes will not appear in the panel if the psychiatric questions are overridden'
              }
            />
          </>
        }
        labelSize={10}
        name={`${input.name}.exclude_if_overridden`}
        component={SelectField}
        options={EXCLUDE_OPTIONS}
      />
    );
  }
  return (
    <Field
      label={'  Allow Psychiatric Override?'}
      labelSize={12}
      name={`${input.name}.allow_override`}
      component={SelectField}
      options={OVERRIDE_OPTIONS}
    />
  );
};

const MedicalRulesForm = ({
  handleSubmit,
  submitting,
  formValues,
  schemesToUpdate,
  onUpdate,
}) => {
  if (!formValues) {
    return null;
  }
  const questions = formValues?.question_exclusions;

  const questionKeys = Object.keys(questions);
  return (
    <Box>
      <Row>
        <Form horizontal onSubmit={handleSubmit(onUpdate)}>
          <h2>Medical Question Triggers</h2>
          <SchemesToUpdate schemes={schemesToUpdate} />
          {questionKeys.map((questionKey) => {
            const question = questions[questionKey];

            return (
              <Col sm={12} key={questionKey}>
                <Field
                  label={question.content}
                  labelSize={10}
                  component={SelectField}
                  name={`question_exclusions.${questionKey}.rule`}
                  options={QUOTE_OPTIONS}
                />

                {questionKey === 'has-psychiatric-condition' && (
                  <Field
                    component={ExclusionField}
                    name={`question_exclusions.${questionKey}`}
                  />
                )}
                <hr />
              </Col>
            );
          })}

          <Col sm={12}>
            <Row>
              <Col sm={12}>
                <Field
                  name="allow_medical_exclusion"
                  label="Allow Medical Exclusion"
                  component={CheckboxGroup}
                  noFormGroup
                  inline
                  labelSize={4}
                  fieldSize={4}
                  options={[{ label: '', value: true }]}
                />
              </Col>
            </Row>
          </Col>
          <Col sm={12}>
            <Field
              name="content"
              type="textarea"
              label={'Reason For Update'}
              labelSize={12}
              rows={5}
              component={TextField}
              validate={required({ message: 'Required' })}
            />
          </Col>
          <Col sm={12}>
            <Button
              bsStyle="primary"
              className="pull-right margin-top"
              isLoading={submitting}
              type="submit"
            >
              Save Changes
            </Button>
          </Col>
        </Form>
      </Row>
    </Box>
  );
};
const FORM_NAME = 'MedicalRulesForm';

export default compose(
  connect((state, props) => {
    // const values = selector(state, 'meta');
    // const questionExclusion = selector(state, 'questions_exclusion');
    // const reason = selector(state, 'data.attributes.content');

    return {
      formValues: getFormValues(FORM_NAME)(state),
      initialValues: {
        content: '',
        schemes: props.schemesToUpdate,
        question_exclusions: props.medicalRules,
        allow_medical_exclusion: props.allowMedicalExclusion,
      },
    };
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(MedicalRulesForm);
